import svgConnect from "../../../../assets/imgs/socials/connects/linkedin.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/linkedin.svg";

import MyImage from "../../../myImage"

const MyIconLinkedin = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'linkedin icon'} sx={sx} />

export default MyIconLinkedin;
